import { useTranslations } from "@mzara/component";
import { useFormationBreadcrumb } from "../../formation/hooks/useFormationBreadcrumb";

export const useFormationDetailsBreadcrumbItems = (formationTitle: string) => {
    const mainBreadcrumb = useFormationBreadcrumb();

    return [...mainBreadcrumb, { label: formationTitle, className: "active" }];
};
